import { FormControl, FormField, FormItem, FormLabel, FormMessage } from "@/components/ui/form";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { UseFormReturn } from "react-hook-form";
import { ProjectFormValues } from "./types";

interface ComplexityFieldProps {
  form: UseFormReturn<ProjectFormValues>;
}

export const ComplexityField = ({ form }: ComplexityFieldProps) => {
  return (
    <FormField
      control={form.control}
      name="complexity"
      render={({ field }) => (
        <FormItem>
          <FormLabel>Complejidad del Proyecto</FormLabel>
          <Select onValueChange={field.onChange} value={field.value}>
            <FormControl>
              <SelectTrigger>
                <SelectValue placeholder="Seleccionar complejidad" />
              </SelectTrigger>
            </FormControl>
            <SelectContent>
              <SelectItem value="low">Baja</SelectItem>
              <SelectItem value="medium">Media</SelectItem>
              <SelectItem value="high">Alta</SelectItem>
            </SelectContent>
          </Select>
          <FormMessage />
        </FormItem>
      )}
    />
  );
};
